export const Errors_DA = {
  // Toasts used for challenges
  error: {
    page: {
      doesntExist: "Denne side findes ikke",
    },
    action: {
      backToHome: "Gå tilbage til forsiden",
    },
  },
};
